export default "__VITE_ASSET__BsbqqTW4__"